import { z } from 'zod';

import { EmailSchema, PhoneNumberSchema } from '@vestigas/utils';

/**
 * Validation schemas for the supplier responsible-person filter options API.
 */

export const zodSupplierResponsiblePersonOptionsQueryParamsSchema = z.object({
  recipientCompanyIds: z.array(z.uuid()).min(1),
});

export const zodSupplierResponsiblePersonOptionSchema = z.object({
  email: EmailSchema.nullable(),
  firstName: z.string().nullable(),
  id: z.uuid(),
  lastName: z.string().nullable(),
  phoneNumber: PhoneNumberSchema.nullable(),
  userId: z.uuid(),
});

export const zodSupplierResponsiblePersonOptionsResponseSchema = z.object({
  data: z.array(zodSupplierResponsiblePersonOptionSchema),
});
